import { ApolloError } from '@apollo/client'

const INVALID_INPUT = 'invalid.input.'
const INVALID_INPUT_PATTERN = /invalid\.input\./g

/**
 * Extracts and formats user-friendly error messages from Apollo GraphQL errors.
 *
 * @param e - ApolloError object from a GraphQL mutation or query
 * @returns A user-friendly error message string
 */
export const getErrorMessage = (e: ApolloError): string => {
  // Check for invalid.input.X pattern
  if (e?.message?.startsWith(INVALID_INPUT)) {
    const field = e?.message.replace(INVALID_INPUT_PATTERN, '')
    return `Invalid input for ${field}`
  }
  return e?.message || 'Something went wrong.'
}
